import { useState } from 'react'
import styled from 'styled-components/macro'

import { Accordion } from '@loadsmart/loadsmart-ui'
import { Text } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

import { formatLastLocation } from '../../presenters/locationPresenter'
import { AccordionBodyWrapper } from '../AccordionBodyWrapper.styles'
import DriverLocationForm from './DriverLocationForm'
import { useShipmentLocationsContext } from './ShipmentLocationsContext'

const IconArrowsCollapse = styled(Icon)`
  transform: rotateZ(180deg);
`

type DriverLocationSelectorProps = {
  readonly shipmentUUID: string
}

function AccordionTrailingIcon(expanded: boolean) {
  return expanded ? (
    <IconArrowsCollapse name="arrows-expanded" data-testid="icon-collapse" />
  ) : (
    <Icon name="arrows-expanded" data-testid="icon-expand" />
  )
}

/**
 * This component is a legacy version and will be removed along with
 * the enableNewTrackingVisibilty feature flag.
 *
 * @deprecated
 */
export default function LegacyDriverLocationSelector({
  shipmentUUID,
}: DriverLocationSelectorProps) {
  const [isOpen, setIsOpen] = useState(true)

  const { locations } = useShipmentLocationsContext()

  function handleExpandChange(open: boolean) {
    setIsOpen(open)
  }

  return (
    <Accordion expanded={isOpen} onExpandedChange={handleExpandChange}>
      <Accordion.Toggle
        leading={<Icon name="pins" width="16" height="16" color="success" />}
        trailing={AccordionTrailingIcon}
      >
        <Text variant="heading-sm">
          Let the shipper know the driver's last location
          <Text variant="body-sm">⦁ {formatLastLocation(locations)}</Text>
        </Text>
      </Accordion.Toggle>
      <AccordionBodyWrapper $overflow={isOpen ? 'initial' : 'auto'}>
        <Accordion.Body>
          <DriverLocationForm shipmentUUID={shipmentUUID} />
        </Accordion.Body>
      </AccordionBodyWrapper>
    </Accordion>
  )
}
